// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"5f2c0490","219":"50e149c4","312":"0cc7e599","394":"afd033e4","478":"344dcb9a","514":"580eaa92","536":"e084e8b1","686":"58217443","695":"a69b332d","820":"dc2dcf15","872":"53d09128"}[chunkId] + ".chunk.js";
};